const NVQUAL_GPU_INFO = [
  'type',
  'ecid',
  'rawEcid',
  'did',
  'prodSerNum',
  'romVersion',
  'pexInfo',
]

const NVQUAL_GPU_INFO_ENTERPRISE = [
  'type',
  'bdf',
  'deviceName',
  'vendor',
  'speed',
  'width',
  'physicalSlot'
]

const NVQUAL_CPU_INFO = [
  'name',
  'architecture',
  'cores',
  'sockets',
  'memorySize',
  'biosVersion',
  'numaNodes'
]

const NVQUAL_SSD_INFO = [
  'model',
  'serialNumber',
  'mountLocation',
  'firmware',
  'speed',
  'width'
]

const NVQUAL_PCIE_INFO = [
  'deviceName',
  'bdf',
  'vendor',
  'speed',
  'width'
]

const NVQUAL_NETWORK_INFO = [
  'deviceName',
  'bdf',
  'vendor',
  'speed',
  'width'
]

export {
  NVQUAL_GPU_INFO,
  NVQUAL_CPU_INFO,
  NVQUAL_PCIE_INFO,
  NVQUAL_SSD_INFO,
  NVQUAL_NETWORK_INFO,
  NVQUAL_GPU_INFO_ENTERPRISE
}